import styled from "styled-components";

export const DescriptionGridItemLabel = styled.div`
    font-size: 0.75rem;
    letter-spacing: 0.0125em;
    line-height: 1.2;
    font-weight: 500;

    color: ${({ theme }) => theme.color.textGrayDairyDarker};

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
